import { Link } from 'react-router-dom';

export default function FeaturedCollection() {
  return (
    <section className="py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto">
        <div className="relative bg-gradient-to-br from-[#1A1A1A] to-[#0D0D0D] rounded-3xl overflow-hidden p-12 md:p-16">
          <div className="grid md:grid-cols-5 gap-12 items-center">
            {/* Left - Product Image */}
            <div className="md:col-span-2">
              <div className="relative h-[600px] rounded-xl overflow-hidden" data-product-shop>
                <img
                  src="https://public.readdy.ai/ai/img_res/0954bfa027ba41d001caf1ccb9d04ac6.jpg"
                  alt="Varsity Legacy Collection"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right - Content */}
            <div className="md:col-span-3 space-y-8">
              <p className="text-xs font-bold tracking-[0.15em] uppercase text-gray-400">
                SIGNATURE COLLECTION
              </p>
              
              <h2 className="text-6xl md:text-7xl lg:text-8xl font-black text-white leading-tight">
                Varsity<br />Legacy
              </h2>
              
              <p className="text-base text-gray-300 leading-relaxed max-w-xl">
                Premium wool blend. Leather sleeves. Embroidered chenille patches. Built to last generations.
              </p>
              
              <div className="flex items-baseline gap-4">
                <span className="text-4xl font-black text-white">$189</span>
                <span className="text-sm text-gray-500 line-through">$249</span>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <button className="bg-white text-black px-10 py-4 rounded-lg font-bold text-sm tracking-wide hover:scale-105 hover:shadow-2xl hover:shadow-white/20 transition-all duration-300 whitespace-nowrap">
                  ADD TO CART
                </button>
                <Link 
                  to="/product/varsity-legacy" 
                  className="border-2 border-white text-white px-10 py-4 rounded-lg font-bold text-sm tracking-wide hover:bg-white hover:text-black transition-all duration-300 text-center whitespace-nowrap"
                >
                  VIEW DETAILS
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}